"use client";

import useIsMobile from "@/hooks/useIsMobile";
import { motion } from "framer-motion";

const directionVariants = {
  left: { x: -60, y: 0 },
  right: { x: 60, y: 0 },
  top: { x: 0, y: -60 },
  bottom: { x: 0, y: 60 },
  "top-left": { x: -40, y: -40 },
  "top-right": { x: 40, y: -40 },
  "bottom-left": { x: -40, y: 40 },
  "bottom-right": { x: 40, y: 40 },
};

export default function TextReveal({
  children,
  delay = 0,
  duration = 0.7,
  direction = "left",
}) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <>{children}</>;
  }

  const initialOffset =
    directionVariants[direction] || directionVariants.bottom;

  return (
    <motion.div
      initial={{
        opacity: 0,
        x: initialOffset.x,
        y: initialOffset.y,
      }}
      whileInView={{
        opacity: 1,
        x: 0,
        y: 0,
      }}
      transition={{
        duration,
        ease: "easeOut",
        delay,
      }}
      viewport={{ once: true, margin: "-50px" }}
    >
      {children}
    </motion.div>
  );
}
